import { render, staticRenderFns } from "./addRightsGroups.vue?vue&type=template&id=c594a582&scoped=true&"
import script from "./addRightsGroups.vue?vue&type=script&lang=js&"
export * from "./addRightsGroups.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/common/nav.less?vue&type=style&index=0&id=c594a582&scoped=true&lang=less&"
import style1 from "../../../assets/css/common/table.less?vue&type=style&index=1&id=c594a582&scoped=true&lang=less&"
import style2 from "./addRightsGroups.vue?vue&type=style&index=2&id=c594a582&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c594a582",
  null
  
)

export default component.exports